<script>
import { Login } from "./APIService";

let userName = "";
let password = "";
let rememberMe;

async function _login(){
	Login(userName, password, rememberMe);
}

</script>


<main class="form-signin col-md-12">
    <div>
      <img class="mb-4" src="Images/logo.png" alt="" width="100" height="100">
      <h1 class="h3 mb-3 fw-normal">Please sign in</h1>
  
      <div class="form-floating">
        <input type="text" class="form-control" id="floatingInput" placeholder="Username" bind:value={userName}>
        <label for="floatingInput">Username</label>
      </div>
      <div class="form-floating">
        <input type="password" class="form-control" id="floatingPassword" placeholder="Password" bind:value={password}>
        <label for="floatingPassword">Password</label>
      </div>
  
      <div class="checkbox mb-3" style="text-align: left;">
          <label>
            <input type="checkbox" bind:checked={rememberMe}> Remember me
          </label>
      </div>
  
      <button class="w-100 btn btn-lg btn-primary" type="submit" on:click={_login}>Sign in</button>
    </div>
</main>

<style>

	main {
		/* height: 100%; */
		text-align: center;
		/* display: flex; */
		align-items: center;
		margin-top: 14%;
		padding-bottom: 40px;
		/* background-color: #f5f5f5; */
		margin-left: auto;
		margin-right: auto;
		background-color: white;
	}
	


    .form-signin {
		width: 100%;
		max-width: 360px;
		padding: 45px;
		border: 1px solid rgba(26, 26, 26, 0.44);
		border-radius: 5px;
		/* background-color: rgb(230, 230, 230); */
		-webkit-box-shadow: 0px 0px 31px 4px rgba(0,0,0,0.5); 
		box-shadow: 0px 0px 31px 4px rgba(0,0,0,0.5);
	}

	.form-signin .checkbox {
	font-weight: 400;
	}

	.form-signin .form-floating:focus-within {
	z-index: 2;
	}

	.form-signin input[type="email"] {
	margin-bottom: -1px;
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
	}

	.form-signin input[type="password"] {
	margin-bottom: 10px;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	}

	.bd-placeholder-img {
        font-size: 1.125rem;
        text-anchor: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
      }

      @media (min-width: 768px) {
        .bd-placeholder-img-lg {
          font-size: 3.5rem;
        }
      }
</style>